<template>
  <div>
    <v-form class="login" @submit.prevent="login" >
      <v-row justify="center">
        <!-- <v-col
          cols="12"
          md="4"
          justify="center"
        >
        Name
          <v-text-field
            dark
            label="First Name"
            outlined
            required
            class="mr-4"
            name="FNAME"
          ></v-text-field>
        </v-col> -->
        <v-col
          cols="12"
          md="5"
        >
        <!-- Email -->
          <v-text-field
            v-model="email"
            type="email"
            label="Email"
            outlined
            required
            class="mr-4"
            name="EMAIL"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="4"
          justify="center"
        >
        <!-- Pword -->
          <v-text-field
            v-model="password"
            type="password"
            label="Password"
            outlined
            required
            class="mr-4"
            name="password"
          ></v-text-field>
        </v-col>
          <!-- Submit button -->
        <v-col
          cols="12"
          md="3"
        >
          <div class="clear">
            <v-btn
              large
              type="submit"
              color="success"
              class="mt-2"
            >
              Register
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {

  name: 'Login',

  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    login() {
      const { email } = this;
      const { password } = this;
      this.$store.dispatch('login', { email, password })
        .then(() => this.$router.push('/'))
        .catch(err => console.log(err));
    },
  },
};
</script>

<style lang="css" scoped>
/** {
  border: 1px solid red;
}*/
</style>
